import { render, staticRenderFns } from "./UserOrganizations.vue?vue&type=template&id=90954328&scoped=true"
import script from "./UserOrganizations.vue?vue&type=script&lang=js"
export * from "./UserOrganizations.vue?vue&type=script&lang=js"
import style0 from "./UserOrganizations.vue?vue&type=style&index=0&id=90954328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90954328",
  null
  
)

export default component.exports